import React, { useState } from 'react';
import { FlexboxColumn } from '../../action/Flexbox';
import SearchBar from '../../action/SearchBar';
import ExpandableCategory from './ExpandableCategory';

function ExpandableCategoryList({ data , handleClick , selected}) {
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearchChange = e => {
    setSearchQuery(e.target.value);
  };

  const filteredData = Object.entries(data).reduce((acc, [categoryName, items]) => {
    const filteredItems = items.filter(item => item?.name?.toLowerCase().startsWith(searchQuery.toLowerCase()));
    if (filteredItems.length > 0) {
      acc[categoryName] = filteredItems;
    }
    return acc;
  }, {});

  return (
    <FlexboxColumn className='expandable_category_list'>
      <SearchBar style={{ width: '100%' }} placeholder='Search Project' onChange={handleSearchChange} />
      {Object.entries(filteredData).map(([categoryName, items]) => (
        <ExpandableCategory key={categoryName} categoryName={categoryName} items={items} handleClick={handleClick} defaultVisibleCount={4} selected={selected} />
      ))}
    </FlexboxColumn>
  );
}

export default ExpandableCategoryList;
